<template>
	<div class="flex">
		<a @click="handleFileClick"
			class="flex-1 flex items-center gap-3 px-1 py-1 rounded relative group/a overflow-hidden"
			:class="[clickToDownload && background ? 'bg-base-100 hover:bg-base-200 cursor-pointer' : clickToDownload ? 'cursor-pointer' : 'cursor-default']"
		>

			<template v-if="!fileTypeIcon.url">
				<DocumentIcon class="w-5 h-5 shrink-0" />
				<span class="truncate select-none" :title="file.name">{{ file.name }}</span>
			</template>
			<template v-else>
				<img :src="fileTypeIcon.url" class="w-5 h-5 shrink-0 rounded" />
				<span class="truncate select-none" :title="file.name">{{ file.name }}</span>
			</template>

			<template v-if="fileTypeIcon && fileTypeIcon.storageIconUrl">
				<img :src="fileTypeIcon.storageIconUrl" class="absolute -top-0.5 left-4 w-4 h-4 bg-white/50 rounded" />
			</template>

			<ArrowTopRightOnSquareIcon v-if="clickToDownload" class="w-4 h-4 text-base-content-light shrink-0 invisible group-hover/a:visible absolute right-1 top-1/2 -translate-y-1/2 bg-base-200" />

		</a>

		<button v-if="!readOnly" type="button" class="btn btn-sm btn-ghost shrink-0" @click.prevent="$emit('remove')">
			<TrashIcon class="w-4 h-4" />
		</button>
	</div>
</template>


<script lang="ts">

import { File } from "@/models/File.model";
import { DocumentIcon, TrashIcon, ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";

export default {

	emits: [
		'remove'
	],

	components: {
		DocumentIcon, TrashIcon, ArrowTopRightOnSquareIcon
	},

	computed: {
		fileTypeIcon() {
			return this.file.getFileTypeIcon() ?? null;
		},
	},

	props: {
		file: {
			type: File,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false
		},
		clickToDownload: {
			type: Boolean,
			default: true
		},
		/**
		 * Whether to show the gray background on the file link.
		 * Set to false when used in contexts that provide their own background (e.g. table rows).
		 */
		background: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		handleFileClick(event: MouseEvent) {
			if (this.clickToDownload) {
				window.open(this.file.url, '_blank');
			}
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	},
}
</script>
